import { gql } from "@apollo/client";

export const findCodeEngagementsById = gql`
  query FindCodeEngagementsById($code: String!) {
    findCodeEngagementsById(code: $code) {
      code
      userType
      points
      usedAt
      status
      rewards {
        id
        name
        walletWithdrawalDate
        claimCreatedDate
        createdDate
        claimUpdatedDate
        unitName
        quantity
        rewardGroupRewardQuantity
        rewardId
      }
      codeGroup {
        codeGroupId
        basicSetup {
          codeGroupName
        }
      }
      campaign {
        id
        title
        titleShort
        activeStartDate
        activeEndDate
      }
      profile {
        id
        userInfo {
          firstName
          middleName
          lastName
          nationalId
          emailAddress
        }
      }
    }
  }
`;
